import React from 'react';
import './scrollup.css';
import { HiOutlineArrowSmUp } from "react-icons/hi";

const ScrollUp = () => {
    window.addEventListener("scroll", function () {
        const scrollUp = document.querySelector(".scrollup");
        if(this.scrollY >= 560) scrollUp.classList.add("show-scroll");
        else scrollUp.classList.remove("show-scroll");
    });

    // تابع جدید برای هندل کردن کلیک
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth' // برای اسکرول نرم
        });
    };
  
    return (
        <button 
            type="button" 
            className="scrollup" 
            onClick={scrollToTop}
            aria-label="بازگشت به بالای صفحه" // برای بهبود دسترسی‌پذیری
        >
            <HiOutlineArrowSmUp className="scrollup__icon"/>
        </button>
    );
}

export default ScrollUp;